import { FacilityCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/facility_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type FacilityCreatedDetailProps = {
  event: FacilityCreatedEvent;
};

export const FacilityCreatedDetail = ({
  event,
}: FacilityCreatedDetailProps) => {
  const facility = event.facility;

  if (!facility) {
    return (
      <Col className="@FacilityCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FacilityCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Facility Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={facility.id?.value} />
          <FieldDisplay label="Name" value={facility.facilityName} />
          <FieldDisplay label="Type" value={facility.facilityType} />
          <FieldDisplay label="Timezone" value={facility.timezone?.name} />
          <IDField
            label="Facility Group ID"
            value={facility.facilityGroupId?.value}
          />
        </div>
      </Col>

      {facility.address && (
        <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
          <span className="text-xs font-medium text-neutral/60">Address</span>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <FieldDisplay
              label="Street Address"
              value={facility.address.streetAddress}
            />
            <FieldDisplay label="City" value={facility.address.city} />
            <FieldDisplay label="State" value={facility.address.state} />
            <FieldDisplay label="Country" value={facility.address.country} />
            <FieldDisplay
              label="Postal Code"
              value={facility.address.postalCode}
            />
          </div>
        </Col>
      )}
    </Col>
  );
};
